module.exports = __webpack_public_path__ + "files/77c5771adaf3c0c82c6712c93f91bb32.png";